import { Namespace, TFunction } from 'react-i18next';
import * as Yup from 'yup';

import { IFormValues } from '../interfaces';
import { isPersonInn, isSnils } from '../services';

export const ValidationSchema = (t: TFunction<Namespace<'validation'>>): Yup.SchemaOf<IFormValues> => {
  const text = () =>
    Yup.string()
      .trim()
      .test('text', t('bad_intake'), (value) => !value?.includes('\0'));
  return Yup.object({
    number: Yup.string()
      .required(t('required'))
      .test(
        'guid',
        t('poaGuid'),
        (value) =>
          !value ||
          /^[0-9a-f]{32}$/i.test(
            value
              .replace('urn:', '')
              .replace('uuid:', '')
              .replace(/^[{}]+|[{}]+$/g, '')
              .replace(/-/g, '')
          )
      ),
    internal_number: text().nullable(),
    issued_on: Yup.string().required(t('required')),
    valid_until: Yup.string()
      .required(t('required'))
      .test('period', t('epd_poa_period_invalid'), function (value) {
        return !value || !this.parent.issued_on || value >= this.parent.issued_on;
      }),
    representative_last_name: text().required(t('required')),
    representative_first_name: text().required(t('required')),
    representative_middle_name: text().nullable(),
    representative_inn: Yup.string()
      .required(t('required'))
      .test('inn', t('poaPersonInn'), (value) => !value || isPersonInn(value)),
    representative_snils: Yup.string()
      .required(t('required'))
      .test('snils', t('poaSnils'), (value) => !value || isSnils(value)),
    representative_position: text().nullable(),
    is_primary: Yup.boolean(),
  });
};
